import React, { Component } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import Parse from 'parse';

import './App.css';

import { Login, Register } from './business';

class App extends Component {
  constructor(props) {
    super(props);

    // Configure Parse
    Parse.initialize('417DBED1-05FD-4343-987F-BB1EFB58B110');
    Parse.serverURL = 'https://gdra.herokuapp.com/parse';
  }

  state = {
    store: { valid: true },
  };

  render() {
    if (this.state.store === null) {
      return <div>Booting...</div>;
    }

    return (
      <BrowserRouter>
        <div>
          <Route exact path="/" component={Login} />
          <Route path="/business/register" component={Register} />
        </div>
      </BrowserRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js